import React from "react";
import classNames from "classnames";
import * as c from "@components/shared/landingPage/lpThreeColSection.module.scss";
import { processMarkdown } from "@utils/markdown";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function LpThreeColSection({ label, heading, subheading, imageOne, imageTwo, imageThree }) {
  const subheadingHtml = processMarkdown(subheading?.subheading);
  const images = [imageOne, imageTwo, imageThree].filter(Boolean);
  return (
    <section className={c.container}>
      <div className={c.textContainer} data-transition="slide-enter-child">
        {label && <p className={classNames(c.eyebrow, "eyebrow")}>{label}</p>}
        {heading && <h2 className={classNames(c.heading, "h2")}>{heading}</h2>}
        {subheadingHtml && (
          <div className={classNames(c.subheading, "p2")} dangerouslySetInnerHTML={{ __html: subheadingHtml }} />
        )}
      </div>

      <div className={c.imagesContainer} data-transition="slide-enter-child">
        {images.map((image, index) => {
          const textHtml = processMarkdown(image.description);

          return (
            <div className={c.column}>
              <GatsbyImage
                key={index}
                image={getImage(image)}
                alt={image.description || `Image ${index + 1}`}
                className={`image-${index + 1}`}
              />
              <div className={classNames(c.description, "p3")} dangerouslySetInnerHTML={{ __html: textHtml }} />
            </div>
          );
        })}
      </div>
    </section>
  );
}
